(() => {
  const initHowToUse = (scope = document) => {
    scope.querySelectorAll('[data-htu]').forEach((root) => {
      if (root.dataset.htuReady === 'true') return;
      root.dataset.htuReady = 'true';

      const track = root.querySelector('[data-htu-track]');
      const cards = [...root.querySelectorAll('[data-htu-card]')];
      const prev = root.querySelector('[data-htu-prev]');
      const next = root.querySelector('[data-htu-next]');
      const progress = root.querySelector('[data-htu-progress]');
      const videos = [...root.querySelectorAll('[data-htu-video]')];

      const loadVideo = (video) => {
        if (!video || video.dataset.loaded === 'true') return;

        video.querySelectorAll('source[data-src]').forEach((source) => {
          source.src = source.dataset.src;
          source.removeAttribute('data-src');
        });

        video.load();
        video.dataset.loaded = 'true';

        if (video.dataset.autoplay === 'true') {
          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {});
          }
        }
      };

      if (videos.length) {
        if ('IntersectionObserver' in window) {
          const videoObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              loadVideo(entry.target);
              observer.unobserve(entry.target);
            });
          }, {
            rootMargin: '250px 0px'
          });

          videos.forEach((video) => videoObserver.observe(video));
        } else {
          videos.forEach(loadVideo);
        }
      }

      if (!track || !cards.length || !prev || !next || !progress) return;

      const isMobile = () => window.matchMedia('(max-width: 749px)').matches;

      const getGap = () => {
        const styles = getComputedStyle(track);
        return parseFloat(styles.columnGap || styles.gap || 0) || 0;
      };

      const getStep = () => {
        const firstCard = cards[0];
        if (!firstCard) return 0;
        return firstCard.getBoundingClientRect().width + getGap();
      };

      const getMaxScroll = () => Math.max(0, track.scrollWidth - track.clientWidth);

      const update = () => {
        if (!isMobile()) return;

        const maxScroll = getMaxScroll();
        const current = Math.max(0, Math.min(track.scrollLeft, maxScroll));

        prev.disabled = current <= 2;
        next.disabled = current >= maxScroll - 2;

        if (maxScroll <= 0) {
          progress.style.width = '100%';
          progress.style.transform = 'translateX(0)';
          return;
        }

        const visibleRatio = Math.min(1, track.clientWidth / track.scrollWidth);
        const thumbWidth = Math.max(18, visibleRatio * 100);
        const travel = 100 - thumbWidth;
        const position = (current / maxScroll) * travel;

        progress.style.width = `${thumbWidth}%`;
        progress.style.transform = `translateX(${position / thumbWidth * 100}%)`;
      };

      const scrollByCard = (direction) => {
        if (!isMobile()) return;

        const step = getStep();
        track.scrollBy({
          left: direction * step,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      };

      prev.addEventListener('click', () => scrollByCard(-1));
      next.addEventListener('click', () => scrollByCard(1));
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);

      requestAnimationFrame(update);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initHowToUse());
  } else {
    initHowToUse();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initHowToUse(event.target);
  });
})();
